import { useCallback, useMemo } from 'react'
import { updateWorkingDays } from '../services/Helper'

/** Minimum business days from today to schedule a webcast recording */
const MINIMUM_RECORDING_DAYS = 4

/** Business days from recording date to minimum publication date by webcast duration (WFGE-13050) */
const getPublicationDateOffset = (duration: number): number => {
  switch (duration) {
    case 60: return 5
    case 90: return 8
    default: return 5 // 30 min
  }
}

export const useWebcast = () => {
  const minimumLiveDate = useMemo(() => {
    const date = new Date()
    date.setDate(updateWorkingDays(date, MINIMUM_RECORDING_DAYS))
    return date
  }, [])

  const getMinimumPublicationDate = useCallback(
    (recordingDate: Date, duration: number): Date => {
      const result = new Date(recordingDate)
      result.setDate(updateWorkingDays(result, getPublicationDateOffset(duration)))
      return result
    },
    []
  )

  return { minimumLiveDate, getMinimumPublicationDate }
}
